import {useState, useEffect, useCallback} from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import { useTheme, styled, Theme } from '@mui/material/styles';
import {
    Grid,
    Box,
    Stack,
    Drawer,Chip,
    IconButton,
    IconButtonProps,
    Typography,
    Tooltip,
    Divider,
    Button,
    CircularProgress,
    List,Menu,
    MenuItem, Select
} from '@mui/material';
import Iconify from 'src/components/iconify';

import BadgeStatus, {BadgeStatusValue} from "../../../../components/badge-status";

import CustomBreadcrumbs from '../../../../components/custom-breadcrumbs';
import { CustomAvatar, CustomAvatarGroup } from '../../../../components/custom-avatar';
// hooks
import useResponsive from '../../../../hooks/useResponsive';
// utils
import axios from '../../../../utils/axios';
// routes
import {PATH_AUTH, PATH_DASHBOARD} from '../../../../routes/paths';
// @types

import '../Agendamentos.css';

// ----------------------------------------------------------------------

import profile from '../img/img_profile.webp';



// ----------------------------------------------------------------------

const NAV_WIDTH = 320;

const NAV_COLLAPSE_WIDTH = 96;




export default function ItemAgendamentos({atendimentoemandamento}:any) {
  
    const theme = useTheme();
    const navigate = useNavigate();
    const isDesktop = useResponsive('up', 'md');

    const [anchorEl, setAnchorEl] = useState(null);

    const [anchorElMobile, setAnchorElMobile] = useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClickMobile = (event: any) => {
    setAnchorElMobile(event.currentTarget);
  }

  const handleCloseMobile = () => {
    setAnchorElMobile(null);
  };

  const irchat = (event: any) => {

      navigate(PATH_DASHBOARD.chat.view(atendimentoemandamento.token));
  };

    const abrirperfil= () => {
        navigate(PATH_DASHBOARD.verperfil(atendimentoemandamento.IDAtendente));
    };

  const handleClose = () => {
    setAnchorEl(null);
  };

    const editarhora= () => {
        navigate(PATH_DASHBOARD.reagendamento(atendimentoemandamento.IDAtendente,atendimentoemandamento.id));
    };

  const [status, setStatus] = useState<BadgeStatusValue>('Offline');

    return (
        <>
            <div className='CardItemAgendamentos' style={{marginBottom: '16px'}}>
                <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                >
                    <div style={{display: 'flex'}} className='infosAgendamentosPage'>
                        <CustomAvatar
                            src={atendimentoemandamento.avatar}
                            sx={{ width: 48, 
                                height: 48, 
                                mr: 1.5
                             }}
                        />

                        <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="flex-start"
                        >
                            <Typography variant='h6'>{atendimentoemandamento.nome}</Typography>
                            <Typography sx={{mb: 1}}>{atendimentoemandamento.TipoAtendente}</Typography>

                            <div style={{display: 'flex'}} className='infoAgendamentos'>
                                <Chip label={atendimentoemandamento.data} variant="outlined" color='primary' icon={<Iconify icon='eva:calendar-outline' sx={{mr: 0.5}} />} sx={{mr: 1}} />
                                <Chip label={atendimentoemandamento.hora}  variant="outlined" color='primary' icon={<Iconify icon='eva:clock-outline' sx={{mr: 0.5}} />} sx={{mr: 1}} />
                            </div>
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                                sx={{mt: 1}}
                                >
                                <Iconify icon="eva:info-outline" sx={{ mr: 1, color: '#637381'}} /> 
                                <Typography variant='subtitle2' sx={{ color: '#637381'}}>  Horário de Brasília</Typography>
                            </Grid>  
                        </Grid>
                    </div>

                    <div className='funcoesAgendamentosPage'>
                    {isDesktop ? (
                        <>
                            <Button variant='contained' onClick={irchat} color='primary'>Chat</Button>

                            <Button
                                className="BotaoMais_AtendentesHistoricoAcolhimentoRecorrente"
                                aria-controls={anchorEl ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={anchorEl ? 'true' : undefined}
                                onClick={handleClick}
                            >
                                <Iconify icon="eva:more-vertical-fill" />
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                MenuListProps={{
                                'aria-labelledby': 'basic-button',
                                }}
                            >
                                <MenuItem onClick={abrirperfil}>Ver Perfil</MenuItem>
                                <MenuItem onClick={editarhora}>Alterar data/hora</MenuItem>
                            </Menu>
                        </>
                    ) : (
                        <>
                            <Button
                                className="BotaoMais_AtendentesHistoricoAcolhimentoRecorrente"
                                aria-controls={anchorElMobile ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={anchorElMobile  ? 'true' : undefined}
                                onClick={handleClickMobile}
                            >
                                <Iconify icon="eva:more-vertical-fill" />
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorElMobile }
                                open={Boolean(anchorElMobile )}
                                onClose={handleCloseMobile}
                                MenuListProps={{
                                'aria-labelledby': 'basic-button',
                                }}
                            >
                                <MenuItem onClick={irchat}>Acessar Chat</MenuItem>
                                <MenuItem onClick={abrirperfil}>Ver Perfil</MenuItem>
                                <MenuItem onClick={editarhora}>Alterar data/hora</MenuItem>
                            </Menu>
                        </>
                    )}
                    
                    </div>

                </Grid>
            </div>
            
        </>
    )
}
